import { currency } from '@ecg-internal/aurora-js-formatters';
import PRICE_TYPE from '../../constants/priceTypes';
import { PriceInfo } from '@/client/types/Listings';

const priceFormatter = (priceInfo: PriceInfo, reserved = false): string => {
  const { priceCents, priceType, suppressZeroCents = false } = priceInfo;

  if (reserved) {
    return `prices.${PRICE_TYPE.RESERVED}`;
  }

  const minBid = priceType === PRICE_TYPE.MIN_BID;
  const fixed = priceType === PRICE_TYPE.FIXED;

  if (!priceType || minBid || fixed) {
    return currency(priceCents, true, suppressZeroCents);
  }

  return `prices.${priceType}`;
};

export default priceFormatter;
